import type { TabsProps } from 'antd';
import { Tabs as BaseTabs } from 'antd';
import classNames from 'classnames';
import type { FC } from 'react';
import type { IProps as IHeaderProps } from '../Header';
import { Header } from '../Header';
import './index.less';

export const TabsHeader: FC<Omit<TabsProps, 'title'> & IHeaderProps> = (
  props,
) => {
  // props
  const { items, title, actions, onBackBefore, ...attrs } = props;

  return (
    <BaseTabs
      {...attrs}
      animated
      items={items}
      renderTabBar={(props, DefaultTabBar) => {
        if (items) {
          const { activeKey, onTabClick } = props;

          return (
            <Header
              role="tablist"
              title={title}
              actions={actions}
              onBackBefore={onBackBefore}
            >
              <ul className="flex-1 flex gap-8 justify-center items-center h-full text-base text-secondary-1">
                {items.map((item) => {
                  const { key, label, disabled } = item;

                  return (
                    <li className="h-full" key={key}>
                      <button
                        type="button"
                        role="tab"
                        disabled={disabled}
                        className={classNames(
                          'relative h-full px-1 transition enabled:hover:font-medium disabled:cursor-not-allowed disabled:text-secondary-3',
                          {
                            'tab-item--active font-medium text-main':
                              key === activeKey,
                          },
                        )}
                        onClick={(e) => onTabClick(key, e)}
                      >
                        {label}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </Header>
          );
        }
        return <DefaultTabBar {...props} />;
      }}
    />
  );
};
